import clsx from 'clsx'
import { ReactNode } from 'react'
export const NswFilterItem = ({
	children,
	className,
}: {
	children: ReactNode
	className?: string
}) => {
	return (
		<div className={clsx('nsw-filters__item', className)}>{children}</div>
	)
}
